import { render, staticRenderFns } from "./IndicatorMetaDataModal.vue?vue&type=template&id=3ea89e54&scoped=true"
import script from "./IndicatorMetaDataModal.vue?vue&type=script&lang=js"
export * from "./IndicatorMetaDataModal.vue?vue&type=script&lang=js"
import style0 from "./IndicatorMetaDataModal.vue?vue&type=style&index=0&id=3ea89e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea89e54",
  null
  
)

export default component.exports